import { render } from "./Addresses.vue?vue&type=template&id=b640275a"
import script from "./Addresses.vue?vue&type=script&lang=js"
export * from "./Addresses.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__